import React, { FC, useState } from 'react';
import { ProjectId } from 'api/models';
import { Project, ProjectDetailTabKeys } from 'api/project';
import { BreadCrumbs } from 'components/molecules/project-details/header/breadcrumbs';
import { ProjectTitle } from 'components/molecules/project-details/header/project-title';
import { ProjectDetailTabs } from 'components/molecules/project-details/header/tabs/tabs';
import { ProjectPlan } from 'components/organisms/projects/project-plan';
import { ProjectDetailsPageTemplate } from 'components/templates/project-details';
import { usePlaceholdersByProjectQuery } from 'queries/placeholder';
import { logger } from 'services';
import { callWorkerWithCleanup } from 'utils/call-worker-with-cleanup';

interface ProjectPlanPageProps {
  project: Project;
}

export const ProjectPlanPage: FC<ProjectPlanPageProps> = ({ project }) => {
  const [_, setLoadededMembersFromIndexDb] = useState(false);

  // update indexedDb with new project data in users and teams list
  // rerenders the component only when a new project is created
  usePlaceholdersByProjectQuery(ProjectId(project.projectId), {
    onSuccess: (teams) => {
      const worker = callWorkerWithCleanup();

      if (project?.teamMembers) {
        worker.workerApi
          .addUsersAndTeamsToNewProject({
            projectId: project.projectId,
            userIds: project.teamMembers.map((u) => u.userId),
            teams,
          })
          .then((rerender: boolean) => {
            if (rerender) {
              setLoadededMembersFromIndexDb(true);
            }
          })
          .catch((error) => {
            logger.error(
              `Error occured while updating newly created projectId:${project.projectId} in users and teams`,
              error,
            );
          })
          .finally(() => {
            worker.cleanup();
          });
      }

      return () => {
        worker.cleanup();
      };
    },
  });

  return (
    <ProjectDetailsPageTemplate
      title={<ProjectTitle project={project} />}
      tabs={
        <ProjectDetailTabs
          projectId={ProjectId(project.projectId)}
          activeTabKey={ProjectDetailTabKeys.Plan}
        />
      }
      documentTitle={project.projectName}
      breadCrumbs={<BreadCrumbs />}
    >
      <ProjectPlan project={project} />
    </ProjectDetailsPageTemplate>
  );
};
